import { removeOmrLocaleCookie, saveOmrLocaleToCookie } from '@ramp106/omrjs-platform'
import { defineStore } from 'pinia'
import { ref } from 'vue'

import { getInitialLocale, getValidLocale } from '@/helpers/locale'
import i18n from '@/plugins/i18n'

export const reset = () => removeOmrLocaleCookie()

export const useLocaleStore = defineStore('locale', () => {
  const initialLocale = getInitialLocale()
  const locale = ref(initialLocale)

  // Sync i18n on init
  i18n.global.locale.value = initialLocale

  function setLocale(newLocale: string) {
    const validLocale = getValidLocale(newLocale, true)!
    i18n.global.locale.value = validLocale
    locale.value = validLocale
    saveOmrLocaleToCookie(validLocale)
  }

  return {
    locale,
    setLocale,
  }
})
